import axiosInstance from '@/core/api'
import type { paths } from '@/schema'

type GetShopItemsQuery =
	paths['/api/admin/shop/items']['get']['parameters']['query']
type GetShopItemsResponse =
	paths['/api/admin/shop/items']['get']['responses']['200']['content']['application/json']
type GetShopItemResponse =
	paths['/api/admin/shop/items/{id}']['get']['responses']['200']['content']['application/json']
type CreateShopItemBody =
	paths['/api/admin/shop/items']['post']['requestBody']['content']['application/json']
type CreateShopItemResponse =
	paths['/api/admin/shop/items']['post']['responses']['201']['content']['application/json']
type UpdateShopItemBody =
	paths['/api/admin/shop/items/{id}']['patch']['requestBody']['content']['application/json']
type UpdateShopItemResponse =
	paths['/api/admin/shop/items/{id}']['patch']['responses']['200']['content']['application/json']
type GetShopItemPresetsResponse =
	paths['/api/admin/shop/items/presets']['get']['responses']['200']['content']['application/json']
type ApplyShopItemPresetResponse =
	paths['/api/admin/shop/items/presets/{presetId}/apply']['post']['responses']['201']['content']['application/json']

export class ShopItemsService {
	static async getShopItems(
		query?: GetShopItemsQuery,
	): Promise<GetShopItemsResponse> {
		const { data } = await axiosInstance.get<GetShopItemsResponse>(
			'/admin/shop/items',
			{
				params: query,
			},
		)
		return data
	}

	static async getShopItem(id: string): Promise<GetShopItemResponse> {
		const { data } = await axiosInstance.get<GetShopItemResponse>(
			`/admin/shop/items/${id}`,
		)
		return data
	}

	static async createShopItem(
		body: CreateShopItemBody,
	): Promise<CreateShopItemResponse> {
		const { data } = await axiosInstance.post<CreateShopItemResponse>(
			'/admin/shop/items',
			body,
		)
		return data
	}

	static async updateShopItem(
		id: string,
		body: UpdateShopItemBody,
	): Promise<UpdateShopItemResponse> {
		const { data } = await axiosInstance.patch<UpdateShopItemResponse>(
			`/admin/shop/items/${id}`,
			body,
		)
		return data
	}

	static async deleteShopItem(id: string): Promise<void> {
		await axiosInstance.delete(`/admin/shop/items/${id}`)
	}

	static async getShopItemPresets(): Promise<GetShopItemPresetsResponse> {
		const { data } = await axiosInstance.get<GetShopItemPresetsResponse>(
			'/admin/shop/items/presets',
		)
		return data
	}

	static async applyShopItemPreset(
		presetId: string,
	): Promise<ApplyShopItemPresetResponse> {
		const { data } = await axiosInstance.post<ApplyShopItemPresetResponse>(
			`/admin/shop/items/presets/${presetId}/apply`,
		)
		return data
	}
}
